export function estaNaRotaMinhaConta(): boolean {
  if (typeof window === 'undefined') {
    return false;
  }
  const path = window.location.pathname;
  const search = window.location.search;
  return path.includes('/minha-conta') || search.includes('pagamento=sucesso');
}
